export default __webpack_public_path__ + "static/media/img-0104-canada-full-face.e1e9630c.png";